     
    <template v-if="formItem.element">
      <a-row :gutter="16">
        <a-col :span="24" v-if="formItem.img">
          <j-image-draw v-if="isDrawImg" :isdraw="`${formItem.draw}`" :imgUrl="`${formItem.img}`" :drawImg="`${formItem.drawImg}`" :issave="true"
            :bizPath="`/project/${projectId}/patient/form/${formItem.id}`" @change="saveDrawChange" />
          <j-image-draw v-else :imgUrl="`${formItem.drawImg || formItem.img}`" />
        </a-col>
        <a-col :span="24">
          <a-space direction="horizontal" :size="16" class="auto-distribute">
            <a-input :id="formItem.id + '_input'" :disabled="!isEdit" @blur="valueChange" v-model="form[formItem.id]"
              placeholder="请输入" v-if="formItem.element.type === elementTypeData.text.value" :maxLength="maxInputLength"/>
            <a-textarea :id="formItem.id + '_input'" :disabled="!isEdit" @blur="valueChange" v-model="form[formItem.id]"
              placeholder="请输入" :rows="2" v-else-if="formItem.element.type === elementTypeData.textarea.value" :maxLength="maxInputLength"/>
            <template v-else-if="formItem.element.type === elementTypeData.number.value">
              <a-input-number :disabled="!isEdit" :max="formItem.element.length || undefined" :readOnly="true"
                @blur="valueChange" v-model="form[formItem.id]" placeholder="请输入"
                :min="formItem.element.minLength || undefined" :precision="formItem.element.reDecimal === '1' ? (formItem.element.decimalPoint===null?2:formItem.element.decimalPoint) : 0"
                style="width: 100%"  />
            </template>
            <a-date-picker :disabled="!isEdit" :inputReadOnly="isPad" @change="valueChange"
              value-format='YYYY-MM-DD HH:mm:ss' show-time v-model="form[formItem.id]" allowClear
              v-else-if="formItem.element.type === elementTypeData.dateTime.value" />
            <a-radio-group :disabled="!isEdit" @change="valueChange" v-model="form[formItem.id]"
              v-else-if="formItem.element.type === elementTypeData.select.value">
              <!--<a-space>-->
              <a-radio @click="clickHandle(dictItem.value)" class="row-block" :value="dictItem.value"
                v-for="(dictItem, index) in formItem.element.dictItemList" :key="index">
                {{ dictItem.text }}
                <j-image-draw v-if="dictItem.img" :imgUrl="`${dictItem.img}`" />
              </a-radio>
              <!--</a-space>-->

            </a-radio-group>
            <a-checkbox-group :disabled="!isEdit" @change="valueChange" v-model="form[formItem.id]"
              v-else-if="formItem.element.type === elementTypeData.check.value">
              <!--<a-space>-->
              <a-checkbox class="row-block" :style="index === 0 ? { marginLeft: '8px' } : {}" :value="dictItem.value"
                v-for="(dictItem, index) in formItem.element.dictItemList" :key="index">
                {{ dictItem.text }}
                <j-image-draw v-if="dictItem.img" :imgUrl="`${dictItem.img}`" />
              </a-checkbox>
              <!--</a-space>-->

            </a-checkbox-group>
            <a-date-picker :disabled="!isEdit" :inputReadOnly="isPad" @change="valueChange" value-format='YYYY-MM-DD'
              v-model="form[formItem.id]" allowClear v-else-if="formItem.element.type === elementTypeData.date.value" />
            <a-time-picker class="main" :disabled="!isEdit" :inputReadOnly="isPad" @change="valueChange"
              value-format='HH:mm' format="HH:mm" v-model="form[formItem.id]" :open.sync="timeOpen" allowClear
              v-else-if="formItem.element.type === elementTypeData.time.value">
              <a-button slot="addon" size="small" type="primary" @click="handleTimeClose">
                关闭
              </a-button>
            </a-time-picker>
            <div v-else-if="formItem.element.type === elementTypeData.qrCode.value">
              扫码功能暂未开放
            </div>
            <div v-else-if="formItem.element.type === elementTypeData.file.value">
              <!-- <div>
          {{ form[formItem.id] }}
        </div> -->
              <!-- <a-upload name="file"
                  class="main"
                  :disabled="!isEdit"
                  :showUploadList="false"
                  :multiple="false"
                  :headers="tokenHeader"
                  :data="{biz:`/project/${projectId}/patient/form/${formItem.id}/${fileType}`}"
                  :action="importExcelUrl"
                  @change="handleImportExcel"
        >
          <a-button type="primary" icon="import">上传文件</a-button>
        </a-upload> -->
              <j-upload v-model="fileList" :bizPath="`/project/${projectId}/patient/form/${formItem.id}/${fileType}`"
                multiple @change2="path => onFileChange(path)">
                <a-button icon="upload" size="small">点击上传</a-button>
              </j-upload>
            </div>
            <a-row v-else-if="formItem.element.type === elementTypeData.slider.value" style="float: left"
              :id="formItem.id + '_input'">
              <a-col :span="18">
                <a-slider :disabled="!isEdit" @afterChange="valueChange" :marks="marks" v-model="form[formItem.id]"
                  :min="formItem.element.minLength || 0" :max="formItem.element.length || 100" />
              </a-col>
              <a-col :span="4" style="margin-top: 10px">
                <a-input-number v-model="form[formItem.id]" :max="formItem.element.length || 100"
                  style="margin-left: 20px" :disabled="true" :min="formItem.element.minLength || 0" />
              </a-col>
            </a-row>
            <div v-else>
              未知的元素
            </div>
            <label v-if="formItem.element">{{ formItem.element.unit || '' }}</label>
            <a-tooltip placement="topLeft" v-if="formItem.description">
              <template slot="title">
                {{ formItem.description }}
              </template>
              <a-icon type="info-circle" style="color: red" />
            </a-tooltip>
          </a-space>
        </a-col>
      </a-row>
    </template>


<script>
import JUpload from "@comp/jeecg/JUpload"
import JImageDraw from '@/components/jeecg/JImageDraw'
import { elementTypeData, CACHE_PROJECT_ID, CACHE_IS_PAD } from '@/constants/project'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import Template from '../setting/Template.vue'

export default {
  name: 'FormViewItemInput',
  components: { JUpload, JImageDraw, },
  props: {
    formItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    enforcement: { //强制修改
      type: Boolean,
      default: false,
    },
    baseData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      projectId: Vue.ls.get(CACHE_PROJECT_ID),
      isPad: Vue.ls.get(CACHE_IS_PAD),
      elementTypeData: elementTypeData,
      timeOpen: false,
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      fileType: '2',
      open: false,
      fileList: []
    }
  },
  created() {
    if (this.formItem.value && this.formItem.value.includes('/')) {
      let files = this.formItem.value.split("、")
      for (var i = 0; i < files.length - 1; i += 2) {
        //this.fileList.push({ name: '方案概览.png', path: '/project/1572115427468570626/patient/form/1839248464152686594/2/fangangailan_1727348002248.png', type: 10 })
        this.fileList.push({ name: files[i], path: files[i + 1], type: 10 })
      }
    }    
  },
  computed: {
    isTemplate() {
      return !this.formItem.formItemId
    },
    isEdit() {
      return this.enforcement || (!this.readOnly && this.formItem.disabled !== '1') || this.isTemplate
    },
    isDrawImg() {
      return this.baseData.status == '1' || this.baseData.status == '2'
    },
    isEditImg(){
      return this.formItem.drawImg!='' && this.formItem.drawImg!=null && this.formItem.drawImg!='undefined'
    },
    marks() {
      const length = this.formItem.element.length || 100
      const minLength = this.formItem.element.minLength || 0
      const half = parseInt((length - minLength) / 2)
      
      const marks = {
        0: `${minLength}`
      }
      if (half > minLength) {
        marks[half+ minLength] = `${half+ minLength}`
      }
      marks[length] = `${length}`
      return marks
    },
    importExcelUrl() {
      return `${window._CONFIG['domianURL']}/sys/common/upload`
    },
    maxInputLength() {
      return this.formItem.element.length || 100000;
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        const div = document.getElementById(this.formItem.id + '_input')
        if (div && div.parentNode && div.parentNode.parentNode) {
          const sParent = div.parentNode.parentNode
          div.style.width = (sParent.clientWidth * 0.9) + 'px'
        }
        // const formInput = document.querySelectorAll('.form-model-item .ant-input');
        // Array.from(formInput).forEach(item=>{
        //   if(item && item.parentNode && item.parentNode.parentNode){
        //     const sParent = item.parentNode.parentNode
        //     item.style.width = (sParent.clientWidth * 0.9) +'px'
        //   }
        // })

      })
    }, 1)
  },
  methods: {
    valueChange() {
      this.$emit('valueChange', { id: this.formItem.id, name: this.formItem.name }, this.form[this.formItem.id])
    },
    handleTimeClose() {
      this.timeOpen = false
    },
    clickHandle(value) {
      this.$nextTick(() => {
        if (this.form[this.formItem.id] === value) {
          this.form[this.formItem.id] = null;
        }
      })
      // if(this.form[this.formItem.id]!==undefined &&this.form[this.formItem.id]!=null ){
      //   this.form[this.formItem.id] = null
      // }
    },
    // handleImportExcel(fileInfo) {
    //   const file = fileInfo.file
    //   if (file.status === 'done' && file.response && file.response.success) {
    //     const filePath = file.response.message
    //     this.$set(this.form, this.formItem.id, filePath)
    //   }

    // },
    onFileChange(path) {
      this.$set(this.form, this.formItem.id, path)
    },
    saveDrawChange(path) {
      this.$set(this.formItem, "drawImg", path)
      this.$set(this.form, this.formItem.id + "_drawImg", path)
      console.log("this.formItem:" + this.formItem)
    },
  }
}
</script>

<style scoped lang="less">
.row-block {
  display: block;
  line-height: 30px;
  float: left;
}

.max-height-img {
  max-height: 280px;
  /* 设置最大高度 */
  width: auto;
  /* 保持宽高比 */
}

.auto-distribute {
  display: flex;
  width: 100%;
  /* 确保 a-space 占据整个宽度 */
}
</style>